// 时间阶段
export const PERIODS_MAPPING = {
  DAY_1: 'day_1',
  WEEK_1: 'week_1',
  MONTH_1: 'month_1',
  MONTH_3: 'month_3',
  MONTH_6: 'month_6',
  MONTH_12: 'month_12',
};

// 时间段名称
export const PERIODS_NAMES_MAPPING: {
  [key: string]: string;
} = {
  [PERIODS_MAPPING.DAY_1]: 'dbi_compare_last_1_day',
  [PERIODS_MAPPING.WEEK_1]: 'dbi_compare_last_1_week',
  [PERIODS_MAPPING.MONTH_1]: 'dbi_compare_last_1_month',
  [PERIODS_MAPPING.MONTH_3]: 'dbi_compare_last_3_month',
  [PERIODS_MAPPING.MONTH_6]: 'dbi_compare_last_6_month',
  [PERIODS_MAPPING.MONTH_12]: 'dbi_compare_last_12_month',
};

// 全部时间段
export const ALL_PERIODS = [
  PERIODS_MAPPING.DAY_1,
  PERIODS_MAPPING.WEEK_1,
  PERIODS_MAPPING.MONTH_1,
  PERIODS_MAPPING.MONTH_3,
  PERIODS_MAPPING.MONTH_6,
  PERIODS_MAPPING.MONTH_12,
];
